export default "__VITE_ASSET__BFUqtHnM__"